__turbopack_context__.v({
  "alert": "AlertInlineMessage-module-scss-module__diqaaW__alert",
  "default": "AlertInlineMessage-module-scss-module__diqaaW__default",
  "error": "AlertInlineMessage-module-scss-module__diqaaW__error",
  "icon": "AlertInlineMessage-module-scss-module__diqaaW__icon",
  "info": "AlertInlineMessage-module-scss-module__diqaaW__info",
  "messageWrapper": "AlertInlineMessage-module-scss-module__diqaaW__messageWrapper",
  "success": "AlertInlineMessage-module-scss-module__diqaaW__success",
  "warning": "AlertInlineMessage-module-scss-module__diqaaW__warning",
});
